import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setIsLoading(true);

        try {
            const response = await axios.post(`${API_BASE_URL}/auth/forgot-password`, { email });
            
            setSuccess(response.data.message);
            setEmail(''); // Clear email field for security
            
        } catch (error) {
            setError(error.response?.data?.message || 'Failed to send password reset email. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-form">
            <h2>Forgot Password</h2>
            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}
            
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={isLoading}
                    />
                </div>
                
                <button type="submit" disabled={isLoading}>
                    {isLoading ? 'Sending...' : 'Send Reset Link'}
                </button>
            </form>
            
            <div className="forgot-password-info">
                <p>Enter your email address and we'll send you a link to reset your password.</p>
                <p className="security-note">
                    <strong>Security Note:</strong> The reset link will expire in 5 minutes for your security.
                </p>
            </div>
            
            <p className="auth-switch">
                Remember your password? <Link to="/auth/login">Login here</Link>
            </p>
        </div>
    );
};

export default ForgotPassword; 